"use client";

import { BORDER, FONT_MONO, SURFACE_LO, TEXT_DIM, VIOLET } from "./palette";

export type ChordPracticeMode = "static" | "tempo";

type Props = {
  mode: ChordPracticeMode;
  onChange: (mode: ChordPracticeMode) => void;
};

export function ChordPracticeModeToggle({ mode, onChange }: Props) {
  return (
    <div
      style={{
        display: "inline-flex",
        padding: 2,
        borderRadius: 999,
        background: SURFACE_LO,
        border: `1px solid ${BORDER}`,
        gap: 2,
        fontFamily: FONT_MONO,
      }}
    >
      {(["static", "tempo"] as const).map((m) => {
        const isActive = mode === m;
        const label = m === "static" ? "Statique" : "Tempo";

        return (
          <button
            key={m}
            type="button"
            onClick={() => onChange(m)}
            disabled={isActive}
            style={{
              padding: "5px 12px",
              borderRadius: 999,
              fontSize: 11,
              fontWeight: 500,
              fontFamily: "inherit",
              background: isActive ? VIOLET : "transparent",
              color: isActive ? "#fff" : TEXT_DIM,
              border: "none",
              cursor: isActive ? "default" : "pointer",
              transition: "background-color 150ms, color 150ms",
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
